<template>
    <div class="inner-page">
        <b-col v-if="!transferItems.length">
            <b-tabs card align="center">
                <b-tab :title="$translate('warehouse_inventory')">
                    <list-items  ref="table">
                    </list-items>
                </b-tab>
                <b-tab :title="$translate('inventory_history')">
                    <HistoryListItems></HistoryListItems>
                </b-tab>
            </b-tabs>
        </b-col>
        <b-col v-else>
            <transfer @set-items="items => getItems(items)" :transferItems="transferItems"
                :title="$translate('transfer_section_items')" />
        </b-col>
    </div>
</template>
<script>
import Transfer from './Transfer.vue'
import ListItems from './ListItems'
import HistoryListItems from './HistoryListItems'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import showItemHelper from '@/mixins/showItemHelper'

import { templates } from '@/exports/jsreport_templates'

export default {
    name: 'inventoryTransfer',
    components: {
        ListItems,
        Transfer,
        HistoryListItems,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('transactionType/fetchOptions')
        ////this.$store.dispatch('masterItem/fetchallMaster')
    },
    mounted() {
        this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [])
    },
    computed: {
        reportList() {
            return [
                {
                    id: 'history-report',
                    value: templates.RPT_SVR_PDF_TEMPLATE,
                    extension: 'pdf',
                    name: 'history-report',
                    label: this.$translate('history_report')
                },
            ]
        },
        reportQuery() {
            return (
                this.$refs.historytable &&
                this.$refs.historytable.getReportQuery()
            )
        },
        transferItems() {
            return this.$store.state.masterItem.transfer_items
        },
    },

    methods: {
        alertSuccess(message) {
            this.doToast(this.$translate('success'), message, 'success')
        },

        showReportDialog() {
            return this.$refs.reportsDialog.show()
        },
    },
}
</script>
<style></style>
